import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './home';
const LoginPage = lazy(() => import('./pages/login/login'));
const NotFoundPage = lazy(() => import('./pages/not-found/not-found'));
const ResetPassword = lazy(() =>
  import('./pages/reset-password/reset-password')
);

const App = () => {
  return (
    <>
      <div className='container-fluid p-0 h-100'>
        <BrowserRouter>
          <Routes>
            <Route path='login' element={<LoginPage />} />
            <Route path='not-found' element={<NotFoundPage />} />
            <Route path='reset-password' element={<ResetPassword />} />
            <Route path='*' element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
      <ToastContainer
        position='bottom-right'
        transition={Slide}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='dark'
      />
    </>
  );
};

export default App;
